module.exports = __webpack_public_path__ + "static/media/mobileContactlessIcon.b81ae48a.svg";